/** @format */
import { css } from 'styled-components';

import { theme } from '@toucan/client/global/theme';

export const styles = css`
    margin-bottom: var(--layout-spacing-32);

    .condition-filter__title {
        display: flex;
        gap: var(--layout-spacing-8);
        align-items: center;
        ${theme.typography.body_large}
        color: var(--colors-text-secondary);
        margin-bottom: var(--layout-spacing-8);

        &.condition-filter__title--hidden {
            display: none;
        }

        .condition-filter__condition-icon svg {
            fill: var(--colors-surface-accent-inverse);
        }
    }

    .condition-filter__options {
        display: flex;
        gap: var(--layout-spacing-8);
    }

    .condition-filter__description {
        ${theme.typography.body_small}
        margin-bottom: var(--layout-spacing-16);

        strong {
            color: var(--colors-text-secondary);
        }
    }
`;
